exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__list___3jJMq{margin:auto 5px}.style__listItem___2Pu3l{display:flex;text-transform:uppercase;font-family:PlayfairDisplay-Regular;font-size:15px;letter-spacing:.7px;color:#333;margin-top:30px;margin-bottom:30px}a .style__listItem___2Pu3l,a:hover .style__listItem___2Pu3l{cursor:pointer;color:#333}.style__bullet___2Nza_{width:16px;height:16px;border:1px solid #f8d0c9;margin-right:16px;transform:rotate(45deg)}", ""]);

// exports
exports.locals = {
	"list": "style__list___3jJMq",
	"listItem": "style__listItem___2Pu3l",
	"bullet": "style__bullet___2Nza_"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/question-list/style.css
// module id = 699
// module chunks = 0